import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import qs from 'query-string';
import { Layout, Typography, Card, Tabs } from 'antd';
// import ReactGA from 'react-ga';
import LoginForm from './LoginForm';
import { GET_ME } from '../../gql/auth';
import PolyuSSO from './PolyuSSO';
import './Login.less';

const { Header, Content } = Layout;
const { Title } = Typography;
const { TabPane } = Tabs;

const Login = () => {
  const url = process.env.REACT_APP_POLYUSSO_AUTH_URL;
  const env = process.env.REACT_APP_ENV;
  console.log(env);
  const redirect = localStorage.getItem('redirect');
  const { data, loading } = useQuery(GET_ME, {
    variables: {
      ignoreError: true,
    },
  });
  const { search } = useLocation();
  const params = qs.parse(search);
  if (!loading && data?.me) {
    if (params.redirect) {
      return <Redirect to={decodeURIComponent(params.redirect)} />;
    }
    if (redirect) {
      localStorage.removeItem('redirect');
      return <Redirect to={decodeURIComponent(redirect)} />;
    }
    return <Redirect to="/home" />;
  }
  if (!loading && !data?.me && params.local !== 'true') {
    // set redirect cookie
    if (params.redirect) {
      localStorage.setItem('redirect', params.redirect);
    }
    window.location.replace(url);
  }
  return !loading && !data?.me && params.local === 'true' ? (
    <Layout style={{ paddingTop: '32px' }}>
      <Header
        style={{
          background: '#f0f2f5',
          textAlign: 'center',
          marginBottom: '48px',
        }}
      >
        <Title level={2}>PMS Login</Title>
      </Header>
      <Content
        style={{
          maxWidth: '100%',
          width: '400px',
          margin: '0 auto',
        }}
      >
        <div className="card-container">
          <Card>
            <Tabs defaultActiveKey="2" centered>
              <TabPane tab="PolyU SSO" key="1">
                <PolyuSSO />
              </TabPane>
              <TabPane tab="PMS local account" key="2">
                <LoginForm />
              </TabPane>
            </Tabs>
          </Card>
        </div>
      </Content>
    </Layout>
  ) : (
    <div>Redirecting to poly SSO login...</div>
  );
};

export default Login;
